import { IProject } from 'redux-store/api/projects';
import {
  ISelectionOption,
  ReminderStatusEnum,
  SelectionStatusEnum,
} from 'redux-store/api/selections';
import { PhaseStatusesEnum } from 'redux-store/types';
import { ISelectController } from 'controllers/select-controller';
import { ITagsSelectProps } from 'widgets/side-panel/sections/activity-feed/components/add-tags-button/components/tags-select';
import { getUpperFirstWithoutUnderline } from '../../../utils/helpers';
import { TSelectionFormOption } from '../utils/types';

export const getSelectionPhaseOptions = (
  phases?: IProject['phases'],
  projectPhaseId?: number
): ISelectController['options'] => {
  if (!phases) {
    return [];
  }

  return phases
    .filter(({ status, id }) => {
      const isExcludedStatus =
        status === PhaseStatusesEnum.COMPLETED || status === PhaseStatusesEnum.OVERDUE;
      return !isExcludedStatus || id === projectPhaseId;
    })
    .map(({ id, title }) => ({
      value: id,
      label: title,
    }));
};

export const getSelectionPhaseItemsOptions = (
  phases?: IProject['phases'],
  phaseId?: number,
  projectPhaseItemId?: number
): ISelectController['options'] => {
  if (!phases || !phaseId) {
    return [];
  }

  const foundedPhaseItems = phases.find(({ id }) => id === phaseId)?.items;

  if (!foundedPhaseItems) {
    return [];
  }

  return foundedPhaseItems
    .filter(({ status, id }) => {
      const isExcludedStatus =
        status === PhaseStatusesEnum.COMPLETED || status === PhaseStatusesEnum.OVERDUE;
      return !isExcludedStatus || id === projectPhaseItemId;
    })
    .map(({ id, title }) => ({
      value: id,
      label: title,
    }));
};

export const getSelectionReminderProfileOptions = (
  profiles?: IProject['profiles']
): ITagsSelectProps['options'] => {
  if (!profiles) {
    return [];
  }

  return profiles.map(({ firstName, lastName, id }) => ({
    id,
    title: `${firstName} ${lastName}`,
  }));
};

export const getOptionsSelectOptions = (
  options: Array<TSelectionFormOption | ISelectionOption>
): ISelectController['options'] =>
  options.map(({ id, title }, index) => ({
    value: id,
    label: title,
  }));

export const STATUS_OPTIONS: ISelectController['options'] = [
  {
    label: getUpperFirstWithoutUnderline(SelectionStatusEnum.APPROVED),
    value: SelectionStatusEnum.APPROVED,
  },
  {
    label: getUpperFirstWithoutUnderline(SelectionStatusEnum.PENDING),
    value: SelectionStatusEnum.PENDING,
  },
];

export const REMINDER_TRIGGER_OPTIONS: ISelectController['options'] = [
  { label: 'Deadline Date', value: ReminderStatusEnum.CUSTOM },
  { label: 'After Schedule Item Completion', value: ReminderStatusEnum.SCHEDULE_PHASE },
  { label: 'No reminder', value: ReminderStatusEnum.UNASSIGNED },
];
